var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-mail_svg__clip0)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6A737D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.145 3.243a.029.029 0 00-.029.029v9.456c0 .017.013.03.03.03h13.709a.029.029 0 00.029-.03V3.271a.029.029 0 00-.03-.028H1.146zM0 3.272c0-.633.513-1.146 1.145-1.146h13.71c.632 0 1.145.513 1.145 1.146v9.456c0 .633-.513 1.146-1.145 1.146H1.145A1.145 1.145 0 010 12.728V3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.356 2.734a.558.558 0 01.783-.102l5.772 4.44a1.786 1.786 0 002.178 0l.34.44-.34-.44 5.772-4.44a.558.558 0 11.68.885L9.77 7.957a2.903 2.903 0 01-3.54 0L.458 3.516a.558.558 0 01-.102-.783z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-mail_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgIconMail;